"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    StickyActionBar: ()=>StickyActionBar
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
require("react");
const index_cjs_namespaceObject = require("../A/index.cjs");
const external_Button_index_cjs_namespaceObject = require("../Button/index.cjs");
const external_Text_index_cjs_namespaceObject = require("../Text/index.cjs");
const external_StickyActionBar_variants_cjs_namespaceObject = require("./StickyActionBar.variants.cjs");
function StickyActionBar({ children, headerContent, actionText, helperText, isLink = false, url, type = 'primary', onClick, secondaryActionText, secondaryOnClick, barType }) {
    const hasSecondaryAction = Boolean(secondaryActionText) && 'actionBar' === barType;
    const { root, mainContainer, textContainer, actionContainer, headerContainer, helperTextSlot, primaryActionContainer, secondaryActionContainer } = (0, external_StickyActionBar_variants_cjs_namespaceObject.stickyActionBar)({
        barType,
        hasSecondaryAction,
        type
    });
    const renderPrimaryAction = ()=>{
        const className = 'w-full';
        return isLink ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.A, {
            href: url,
            type: type ?? 'primaryShop',
            className: className,
            size: "lg",
            shadow: true,
            children: actionText
        }) : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Button_index_cjs_namespaceObject.Button, {
            type: type ?? 'primary',
            className: className,
            size: "lg",
            shadow: true,
            onClick: onClick,
            children: actionText
        });
    };
    const renderSecondaryAction = ()=>{
        if (!hasSecondaryAction) return null;
        const className = 'w-full';
        return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Button_index_cjs_namespaceObject.Button, {
            type: "tertiary",
            size: "lg",
            className: className,
            onClick: secondaryOnClick,
            children: secondaryActionText
        });
    };
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
        className: root(),
        children: [
            headerContent && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                className: headerContainer(),
                children: headerContent
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                className: "px-4 pb-2 pt-4",
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                        className: mainContainer(),
                        children: [
                            children && 'bookBar' === barType && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                className: textContainer(),
                                children: children
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                className: actionContainer(),
                                children: hasSecondaryAction ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                            className: secondaryActionContainer(),
                                            children: renderSecondaryAction()
                                        }),
                                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                            className: primaryActionContainer(),
                                            children: renderPrimaryAction()
                                        })
                                    ]
                                }) : renderPrimaryAction()
                            })
                        ]
                    }),
                    helperText && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Text_index_cjs_namespaceObject.P, {
                        className: helperTextSlot(),
                        palette: "neutral",
                        shade: "13",
                        children: helperText
                    })
                ]
            })
        ]
    });
}
exports.StickyActionBar = __webpack_exports__.StickyActionBar;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "StickyActionBar"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
